// 存放需要被缓存的地址
const keepAlivePath =
  [
  ]

export { keepAlivePath }
